/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import SoftTypography from "components/SoftTypography";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "wrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

export default function Table038C({ formData, setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      typeSpending: "",
      spending: "",
      taxId: "",
      province: "Tỉnh A",
      district: "",
      cqt: "",
      tax12: 0,
      tax13: 0,
      tax14: 0,
      tax15: 0,
      tax16: 0,
      tax17: 0,
      tax18: 0,
    },
  ]);
  const [dataProvince, setDataProvince] = useState([]);
  useEffect(() => {
    setFieldValue("valuesTable", data);

    let result = [];
    result = data.filter(function (element) {
      return result.includes(element.province) || element.province === ""
        ? ""
        : result.push(element.province);
    });
    console.log(result);
    setDataProvince(result);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        typeSpending: "",
        spending: "",
        taxId: "",
        province: "",
        district: "",
        cqt: "",
        tax12: 0,
        tax13: 0,
        tax14: 0,
        tax15: 0,
        tax16: 0,
        tax17: 0,
        tax18: 0,
      },
    ]);
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={2} style={{ textAlign: "center", width: 10 }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 200 }}>
                Loại chi tiêu
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 200 }}>
                Chi tiêu
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mã số thuế/Mã địa điểm kinh doanh
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Địa bàn hoạt động sản xuất, kinh doanh
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Cơ quan thuế quản lý địa bàn nhận phân bố
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Xác định tỷ lệ phân bố
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TNDN phải nộp cả năm theo quyết toán cho từng tỉnh
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TNDN nộp thừa kỳ trước chuyển sang kỳ này
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TNDN đã tạm nộp cho từng tỉnh
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Chênh lệch giữa số thuế phải nộp và số thuế đã tạm nộp trong năm
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TNDN còn phải nộp cho từng tỉnh
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>Tỉnh</Td>
              <Td style={{ textAlign: "center" }}>Huyện</Td>
              <Td style={{ textAlign: "center" }}>Cơ quan Thuế cấp chi Cục</Td>
              <Td style={{ textAlign: "center" }}>Doanh thu bán vé thực tế trên địa bàn</Td>
              <Td style={{ textAlign: "center" }}>Tỷ lệ phân bổ (%)</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>[06]</Td>
              <Td style={{ textAlign: "center" }}></Td>
              <Td style={{ textAlign: "center" }}>[07]</Td>
              <Td style={{ textAlign: "center" }}>[08]</Td>
              <Td style={{ textAlign: "center" }}>[10]</Td>
              <Td style={{ textAlign: "center" }}>[09]</Td>
              <Td style={{ textAlign: "center" }}>[11]</Td>
              <Td style={{ textAlign: "center" }}>[12]</Td>
              <Td style={{ textAlign: "center" }}>[13] = [12] / [05]</Td>
              <Td style={{ textAlign: "center" }}>[14] = [13] x [04]</Td>
              <Td style={{ textAlign: "center" }}>[15]</Td>
              <Td style={{ textAlign: "center" }}>[16]</Td>
              <Td style={{ textAlign: "center" }}>[17] = [14] - [16]</Td>
              <Td style={{ textAlign: "center" }}>[18] = [14] - [15] - [16]</Td>
            </tr>

            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {+index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "typeSpending", e.target.value)}
                  >
                    <option value="value1">Tỉnh nơi đóng trụ sở chính</option>
                    <option value="value2">
                      Cơ sở sản xuất khác tỉnh (trừ nhà máy thủy điện nằm trên nhiều tỉnh)
                    </option>
                    <option value="value3">
                      Cơ sở sản xuất khác tỉnh là nhà máy thủy điện nằm trên nhiều tỉnh
                    </option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="spending"
                    value={item.spending}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxId"
                    value={item.taxId}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "province", e.target.value)}
                  >
                    <option value="Tỉnh A">Tỉnh A</option>
                    <option value="Tỉnh B">Tỉnh B</option>
                    <option value="Tỉnh C">Tỉnh C</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "district", e.target.value)}
                  >
                    <option value="Huyện A">Huyện A</option>
                    <option value="Huyện B">Huyện B</option>
                    <option value="Huyện C">Huyện C</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "cqt", e.target.value)}
                  >
                    <option value="value1">Cơ quan thuế A</option>
                    <option value="value2">Cơ quan thuế B</option>
                    <option value="value3">Cơ quan thuế C</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="tax12"
                    value={item.tax12}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="tax13"
                    value={item.tax13}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    readOnlyBackground={true}
                    readOnly={true}
                    id={item.id}
                    name="tax14"
                    value={item.tax14}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="tax15"
                    value={item.tax15}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="tax16"
                    value={item.tax16}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    readOnlyBackground={true}
                    readOnly={true}
                    id={item.id}
                    name="tax17"
                    value={item.tax17}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    readOnlyBackground={true}
                    readOnly={true}
                    id={item.id}
                    name="tax18"
                    value={item.tax18}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  width: "100%",
                  fontWeight: "bold",
                }}
                colSpan={8}
              >
                Cộng theo từng tỉnh
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              />
            </tr>
            {dataProvince.map((item, index) => (
              <tr key={index}>
                <Td
                  className="toggle-button"
                  style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}
                >
                  {+index + 1}
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                  colSpan={8}
                >
                  <InputTable
                    value={item.province}
                    readOnlyBackground={true}
                    readOnly={true}
                    fontWeight={"bold"}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    fontWeight={"bold"}
                    readOnlyBackground={true}
                    readOnly={true}
                    id={item.id}
                    name="tax14"
                    value={item.tax14}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    fontWeight={"bold"}
                    readOnlyBackground={true}
                    readOnly={true}
                    id={item.id}
                    name="tax15"
                    value={item.tax15}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    fontWeight={"bold"}
                    readOnlyBackground={true}
                    readOnly={true}
                    id={item.id}
                    name="tax16"
                    value={item.tax16}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    fontWeight={"bold"}
                    readOnlyBackground={true}
                    readOnly={true}
                    id={item.id}
                    name="tax17"
                    value={item.tax17}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    fontWeight={"bold"}
                    readOnlyBackground={true}
                    readOnly={true}
                    id={item.id}
                    name="tax18"
                    value={item.tax18}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  width: "100%",
                  fontWeight: "bold",
                }}
                colSpan={8}
              >
                Cộng các tỉnh [20]
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  fontWeight={"bold"}
                  readOnlyBackground={true}
                  readOnly={true}
                  value={0}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  fontWeight={"bold"}
                  readOnlyBackground={true}
                  readOnly={true}
                  value={0}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  fontWeight={"bold"}
                  readOnlyBackground={true}
                  readOnly={true}
                  value={0}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  fontWeight={"bold"}
                  readOnlyBackground={true}
                  readOnly={true}
                  value={0}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  fontWeight={"bold"}
                  readOnlyBackground={true}
                  readOnly={true}
                  value={0}
                />
              </Td>
            </tr>
            <tr>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  width: "100%",
                  fontWeight: "bold",
                }}
                colSpan={8}
              >
                Số thuế phải nộp còn lại phân bố cho Tỉnh ... nơi đóng trụ sở chính (= [04] - Cộng
                các tỉnh) [21]
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  fontWeight={"bold"}
                  readOnlyBackground={true}
                  readOnly={true}
                  value={0}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              />

              <Td
                style={{
                  background: "#ddeff3",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                }}
              />
            </tr>
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, readOnlyBackground, fontWeight, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: readOnlyBackground === true ? "#ddeff3" : "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        minWidth: 180,
        borderRadius: "0.5rem",
        fontWeight: fontWeight,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
